import axios from "axios";
// 使用element-ui Message做消息提醒
import { ElMessage } from "element-plus";
import cookie from "../assets/js/cookie";

//正式
const campusPath = '/campus';
//219
// const campusPath = '/campus2';

const getBaseUrl = (env) => {
  let base = {
    production: "/",
    development: "http://localhost:8080",
    test: "http://localhost:8080",
  }[env];
  if (!base) {
    base = "";
  }
  return base;
};
//1. 创建新的axios实例，
const service = axios.create({
  // 公共接口--这里注意后面会讲
  method: "POST",
  withCredentials: false,
  baseURL: getBaseUrl(process.env.BASE_API),
  // 超时时间 单位是ms，这里设置了15s的超时时间
  timeout: 15 * 1000,
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
    "Access-Control-Allow-Origin": "*",
  },
});
// 2.请求拦截器
service.interceptors.request.use(
  (config) => {
    //发请求前做的一些处理，数据转化，配置请求头，设置token,设置loading等，根据需求去添加
    // console.log(config.data);
    // config.data = JSON.stringify(config.data); //数据转化,也可以使用qs转换

    let college_user = cookie.getCookie("college_user");
    let userInfo = {};
    if (college_user && college_user != "undefined") {
      userInfo = JSON.parse(college_user);
    }
    let contentType = "application/x-www-form-urlencoded;";
    if (config.url.indexOf("add_front_learn_resource_record") >= 0 ||
      config.url.indexOf("/personnelapi/add_pUserCertificate") >= 0 ||
      config.url.indexOf("/personnelapi/query_front_skill_train_statistics") >= 0 ||
      config.url.indexOf("/competitionapi/register") >= 0 || config.url.indexOf("/personnelapi/add_front_question_resource_record") >= 0) {
      contentType = "application/json;charset=UTF-8";
      config.data = JSON.stringify(config.params);
    }
    if (config.url.indexOf("/query_teacher_home_view_report_pdf") >= 0) {
      contentType = "multipart/form-data";
      config.data = config.params;
      config.transformRequest = [function () {
        return config.params;
      }]
    }
    config.headers = {
      //     // 设置后端需要的传参类型
      token: cookie.getCookie("college_token"),
      collegetoken: cookie.getCookie("college_token"),
      pccollege: userInfo && userInfo.college ? userInfo.college : "",
      // "pccollege": userInfo.college,
      "Content-Type": contentType,
      //     "Access-Control-Allow-Origin": "*"
      //     //     "pccollege": JSON.parse(getCookie("college_user")).college,
      //     //     "collegetoken": getCookie('college_token'),
    };
    //如有需要：注意使用token的时候需要引入cookie方法或者用本地localStorage等方法，推荐js-cookie
    // const token = getCookie('college_token');//这里取token之前，你肯定需要先拿到token,存一下
    // if (token) {
    //     config.params = { 'token': token } //如果要求携带在参数中
    //     config.headers.token = token; //如果要求携带在请求头中
    // }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

// 添加响应拦截器
service.interceptors.response.use(
  function (response) {
    // console.log(response)
    // 2xx 范围内的状态码都会触发该函数。
    // 对响应数据做点什么
    // dataAxios 是 axios 返回数据中的 data
    const dataAxios = response.data;
    // 这个状态码是和后端约定的
    // const code = dataAxios.reset
    if (dataAxios.errorcode == "e0003") {
      ElMessage.error(dataAxios.msg);
      cookie.clearCookies();
      window.location.href = campusPath;
    } else if (dataAxios.errorcode == "e2006") {
      ElMessage.error(dataAxios.msg);
    } else {
      if (dataAxios.status === 1) {
        ElMessage.error(dataAxios.msg);
      }
    }
    return dataAxios;
  },
  function (error) {
    // 超出 2xx 范围的状态码都会触发该函数。
    // 对响应错误做点什么
    // console.log(error);
    //     /***** 接收到异常响应的处理开始 *****/
    if (error && error.response) {
      // 1.公共错误处理
      // 2.根据响应码具体处理
      switch (error.response.status) {
        case 400:
          error.message = "错误请求";
          break;
        case "e0003":
          error.message = "登录已失效，请重新登录";
          cookie.clearCookies();
          window.location.href = campusPath;
          break;
        case 403:
          error.message = "拒绝访问";
          break;
        case 404:
          error.message = "请求错误,未找到该资源";
          // window.location.href = "/NotFound"
          //window.location.href = campusPath
          break;
        case 405:
          error.message = "请求方法未允许";
          break;
        case 408:
          error.message = "请求超时";
          break;
        case 500:
          error.message = "服务器端出错";
          break;
        case 501:
          error.message = "网络未实现";
          break;
        case 502:
          error.message = "网络错误";
          break;
        case 503:
          error.message = "服务不可用";
          break;
        case 504:
          error.message = "网络超时";
          break;
        case 505:
          error.message = "http版本不支持该请求";
          break;
        default:
          error.message = `连接错误${error.response.status}`;
      }
    } else {
      // 超时处理
      if (JSON.stringify(error).includes("timeout")) {
        ElMessage.error("服务器响应超时，请刷新当前页");
      }
      error.message = "连接服务器失败";
    }
    // return Promise.reject(error)
    // ElMessage.error(error.message);
    /***** 处理结束 *****/
    //如果不需要错误处理，以上的处理过程都可省略
    return Promise.resolve(error.response);
  }
);

//4.导入文件
export default service;
